
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { getProductionLines } from '@pazion/pazion-catalog/src/services/catalog-service';
import ProductionsListingMixin from "@pazion/pazion-catalog/src/views/productions/mixins/production-listing.mixin";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazLoader from '@pazion/pazion-core/src/components/utils/PazLoader.vue';
import type { IproductionCutInstance, IProductionRecord } from '@pazion/pazion-catalog/src/models/production.model';
import { SingleFilterType } from "@pazion/pazion-catalog/src/models/base"
import ProductionFilterPanel from './parts/ProductionFilterPanel.vue';
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import {DataTableHeader} from "vuetify";
import {formatDateTime} from "@pazion/pazion-core/src/services/base-service";


@Component({
  components: {
    PazToast,
    PazTooltipButton,
    PazLoader,
    ProductionFilterPanel
  },
  methods:{
    formatDateTime,
  }
})
export default class ProductionDetails extends Mixins(
  ProductionsListingMixin, PermissionService
) {

  @Prop() detailsProductionProp: IproductionCutInstance;
  @Prop({ default: null }) sku!: string|null;

  public productName: string = '';

  public filterObjectProp: { [key: string]: any };
  public selectedItems = [] as unknown as IproductionCutInstance;
  public itemloading: boolean = false;


  public tableHeadersDetails: DataTableHeader[]= [
    // {
    //   text: "SKU",
    //   align: "left",
    //   class: "cell-truncate nowrap",
    //   sortable: false,
    //   cellClass: "nowrap",
    //   value: "SKU",
    //   groupable: true
    // },
    {
      text: "Business",
      align: "left",
      class: "cell-truncate",
      sortable: false,
      value: "business",
      groupable: false,
      width: "25%"
    },
    {
      text: "Length",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "orderLine.length",
      groupable: false
    },
    {
      text: "Width",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "orderLine.width",
      groupable: false
    },{
      text: "Height",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: false,
      cellClass: "nowrap",
      value: "orderLine.height",
      groupable: false
    },
    {
      text: "QTY",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "orderLine.quantity",
      groupable: false
    },
    {
      text: "Notes",
      align: "left",
      class: "cell-truncate",
      sortable: false,
      value: "notes",
      groupable: false,
      width: "25%"
    },
    {
      text: "Production at",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: 'production.productionAt',
      groupable: false
    },
    {
      text: "Deliver at",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: 'production.deliverAt',
      groupable: false
    },
    {
      text: "Worktype",
      align: "left",
      class: "cell-truncate nowrap",
      sortable: true,
      cellClass: "nowrap",
      value: "worktype",
      groupable: false
    },
    {
      text: "Actions",
      align: "right",
      value: "actions",
      groupable: false
    }

  ];

  get getTableHeadersDetails(){

    const prodConfig = this.getUserProfile?.config?.config?.production;
    return this.tableHeadersDetails.filter(
        (header) => {
          if(header.value == 'orderLine.height'){
            return prodConfig?.useHeight == true ? header : null;
          }
          return header;
        }
    );
  }

  get getTitle(){
    return this.sku + ' - ' + this.productName;
  }

  async onChangeStatus(item: IproductionCutInstance, status: string) {
    const res = await this.onChangeLineStatus(item, status, true)
    if (res) {
      this.$refs.filterPanel.onChangeItemsFilter(true)
    }
  }

  async fethDetails(filter: SingleFilterType) {
    const fullFilter = filter || {};
    if(this.sku) {
      Object.assign(fullFilter, {'p.sku': this.sku})
    }
    const res = await getProductionLines(
      {
        expand: 'orderLine,forceProduct', filter: JSON.stringify(fullFilter)
      })
    if (res){
      this.productName = res[0]?.orderLine?.product?.name ?? "";
      return res
    }
    return [];
  }

  convertFiltersKey(filters: SingleFilterType) {
    const multi = {}
    Object.entries(filters)
      .forEach(([key, val]) => {
        key === 'deliverAt' ? (multi[`p.${key}`] = val) : (multi[`${key}`] = val)
      })
    return multi
  }

  async setFilters(filters: SingleFilterType) {
    let convertedFilters = filters;
    this.selectedItems = await this.getRecordDetails(convertedFilters)
  }

  async getRecordDetails(filter: SingleFilterType) {
    const res = await this.fethDetails(filter);
    if (res) {
      return res
    }
  }

}//
